export enum SideNavStatus {
    EDIT = "edit",
    DONE = "check-circle",
    ERROR = "alert-triangle",
}
